import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["FREE"],
  _excluded2 = ["FREE"];
import { useMemo } from 'react';
import { useTierQueryParam } from '../../../hooks/useTierQueryParam';
import { filterProductsConfigByTab } from '../../utils/tabFiltering';
import { useIsUngatedForV2PublicHubPages } from '../gating/useIsUngated';
import { useIsInAppAuth } from '../user/useUserInfo';
export const useTabAwareProductsConfig = fullConfig => {
  const tier = useTierQueryParam();
  const isInAppAuth = useIsInAppAuth();
  const showPublicTabsOnV2 = useIsUngatedForV2PublicHubPages();
  return useMemo(() => {
    const isPublic = !isInAppAuth;

    // In-app pages: filter out FREE card (should only show on public pages)
    if (!isPublic) {
      const configWithoutFree = _objectWithoutPropertiesLoose(fullConfig, _excluded);
      return configWithoutFree;
    }

    // Public pages without V2 gate: filter out FREE card
    if (!showPublicTabsOnV2) {
      const configWithoutFree = _objectWithoutPropertiesLoose(fullConfig, _excluded2);
      return configWithoutFree;
    }

    // V2 public pages: use tier query param instead of tab URL segment
    // When tier=enterprise, show only Professional and Enterprise
    // Otherwise, show all products
    if (tier === 'enterprise') {
      return filterProductsConfigByTab(fullConfig, 'enterprise');
    }
    return fullConfig;
  }, [fullConfig, tier, isInAppAuth, showPublicTabsOnV2]);
};